export default "/images/vendor/flag-icon-css/flags/4x3/ms.svg?9474f8cf128ce6813e2d501b08cfd7a0";